import { ClipboardList, Rocket, Eye, CheckCircle, type LucideIcon } from '../../../icons';
import type { TaskStatus } from '../../../api/tasks';
import './TaskStatusIcon.css';

/**
 * TaskStatusIcon (2026-06-10) — TASK_STATUS_META.emoji(📋🚀👀✅) 의 인라인 SVG 대체.
 *
 * 이모지 금지 규칙 — UI 아이콘은 lucide 인라인 SVG 사용. 색상은 currentColor 상속이라
 * 기존 meta.color 를 주던 부모 span 의 style/color 가 그대로 적용된다.
 * TASK_STATUS_META.emoji 필드 자체는 호환성 위해 보존 (소스 회귀 금지 — additive only).
 */
const STATUS_ICON: Record<TaskStatus, LucideIcon> = {
  TODO: ClipboardList,
  IN_PROGRESS: Rocket,
  REVIEW: Eye,
  DONE: CheckCircle,
};

interface TaskStatusIconProps {
  status: TaskStatus;
  size?: number;
}

export function TaskStatusIcon({ status, size = 14 }: TaskStatusIconProps) {
  const Icon = STATUS_ICON[status] ?? ClipboardList;
  return <Icon size={size} aria-hidden="true" />;
}
